import React from "react"
import { Helmet } from "react-helmet"

import { GROUP } from "@shared/config"
import { useAccount, useSchedule } from "@shared/contexts"

export default function MetaData() {
  const { schedule } = useSchedule()
  const { account } = useAccount()

  const streamerNickname = schedule?.user.nickname
  const title = schedule?.title
  const role = account.viewer?.role
  const hasValidContents = streamerNickname && title && role

  if (!hasValidContents || GROUP.STREAMER.includes(role!)) {
    return null
  }

  return (
    <Helmet>
      <title>{`${streamerNickname} 파트너방송 | 주식은 와우넷`}</title>
      <meta property="og:description" content={title} />
      <meta name="description" content={title} />
    </Helmet>
  )
}
